import React, { Component } from "react";
import {
  Input,
  Select,
  Row,
  Col,
  Modal,
  Form,
  Radio,
  Upload,
  Button,
  DatePicker,
  InputNumber,
  message,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { getSid,tokenConfig } from "@/public/utils";
import common from "@/public/common";
import moment from "moment";
import "./index.less";
import { ajaxApi, fileDownloadApiHui, format, getMethod, downloadApi } from "@/server";
import _, { get, set } from 'lodash'

import { getCookieInfo, moneyToUpper } from './utils'
import { reseiptTypeObj } from './config'
import { objToArr, Arabia_to_Chinese, getCookieNew } from "@/public/utils";

const { TextArea } = Input;
const { Option } = Select;
var { RealName, UserName, UserID } = getCookieInfo()

// var apiHost = 'http://192.168.10.67:8120/' || common.SapUrl
var apiHost = common.SapUrl


export default class AddModal extends Component {
  constructor(props) {
    super(props);
    this.form = null;
    this.multiForm = null;
    this.state = {
      dialogTitle: this.props.dialogTitle,
      //   visible: this.props.visible,
      type: this.props.type,
      // statusOptions: objToArr(),
      purchaseOptions: this.props.purchaseOptions,
      btnParams: {
        invoiceType: "",
      },
      renderInvoiceType: "",
      amountTaxUpper: "",
      taxUpper: "",
      saveDisabled: false,
      auditDisabled: false,
      submitDisabled: false,
      addParams: {
        invoice_id: "", //发票id创建时传空,编辑必传
        buyer_no: "", //采购主体编码
        buyer_name: "", //采购主体名称
        buyer_tax_no: "", //购方税号
        invoice_type: "", //发票类型
        invoice_code: "", //发票代码
        invoice_no: "", //发票号码
        total_amount: "", //含税金额
        tax_amount: "", //发票税额
        remark: "", //备注
        url: "", //附件地址
        invoice_date: "", //开票日期
        status: "", //状态
        adder: RealName, //创建人姓名
        adder_py: UserName, //创建人拼音
        adder_id: UserID, //创建人id
        // auditer: "", //审核人姓名
        // auditer_py: "", //审核人拼音
        // auditer_id: "", //审核人id
        invoice_source: "02", //发票来源 00 系统 01财务人工 02采购人工
      },
      multiParams: {
        buyer_no: "", //采购主体编码
        buyer_name: "", //采购主体名称
        buyer_tax_no: "", //购方税号
        url: "", //文件地址
        status: "", // 0草稿 1提交审核 2审核通过
        adder: RealName, //创建人姓名, //创建人
        adder_py: UserName, //创建人拼音
        adder_id: UserID, //创建人id, //创建人id
        file: "",
      },
      editData: this.props.editData,
      loading04: false,
      loading03: false,
      loading02: false,
      fileList: [],
      addFileList: [{ url: "" }],
      multiFileList: [],
      multiDetailFileList: [],
      fileList: [],
      renderInvoiceNo: '',
      renderInvoiceNo: "",
      invoice_no_num:0,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      dialogTitle: nextProps.dialogTitle,
      //   visible: nextProps.visible,
      type: nextProps.type,
      editData: nextProps.editData,
    });
  }
  componentDidMount() {
    let { type, editData } = this.state;
    if (type === "edit") {
      this.form.setFieldsValue({
        ...this.state.editData,
        invoice_date: editData.invoice_date ? moment(editData.invoice_date) : null,
      });
    }
    this.getDetailFile();
    this.setState({
      renderInvoiceCode: get(editData, 'invoice_code'),
      renderInvoiceNo: get(editData, 'invoice_no'),
      invoice_no_num:get(editData, 'invoice_no')?get(_.compact(get(editData, 'invoice_no').split(',')),'length'):0
    })
  }
  getDetailFile() {
    let { type, editData, addParams } = this.state;
    if (type === "edit" || type === "audit") {
      var { invoice_file_list } = editData
      addParams.invoice_file_list = invoice_file_list
      var fileList = invoice_file_list.map(item => {
        var { org_name, file_name } = item
        return { name: org_name, url: file_name, status: 'done' }
      })
      this.form.setFieldsValue({ appendix: fileList })
      this.setState({
        fileList,
        addParams,
      });
    }
  }

  getUrl = async (file_name) => {
    try {
      let formData = new FormData();
      formData.append("file_name", file_name);
      let res = await ajaxApi({
        url: apiHost + "invoice/fims/file/download",
        params: formData,
      })
      return get(res.data.data, '0')
    } catch (err) { console.log(err); return null }
  }
  save = () => {
    let { addParams, type,multiParams } = this.state;
    let form = type === "add" || type === "edit" ? this.form : this.multiForm;
    form
      .validateFields()
      .then((values) => {
        addParams.status = "00";
        multiParams.status = "00";
        this.setState(
          {
            saveDisabled: true,
            addParams,
          },
          () => {
            this.createInvoice("saveDisabled");
          }
        );
      })
      .catch((e) => { });
  };
  submit = () => {
    let { addParams, type, multiParams } = this.state;
    let form = type === "add" || type === "edit" ? this.form : this.multiForm;
    form &&
      form
        .validateFields()
        .then((values) => {
          addParams.status = "02";
          multiParams.status = "02";
          this.setState(
            {
              submitDisabled: true,
              addParams,
            },
            () => {
              this.createInvoice("submitDisabled");
            }
          );
        })
        .catch((e) => { });
  };
  createInvoice = _.debounce((loadingStatus) => {
    let {
      addParams,
      editData,
      type,
      multiParams,
      purchaseOptions
    } = this.state;
    var handle = {
      'submitDisabled':'提交',
      'saveDisabled':'保存'
    }
    this.setState({
      [loadingStatus]: false,
    });
    let form = type === "add" || type === "edit" ? this.form : this.multiForm;
    const formData = new FormData();
    if (type === "multiAdd") {
      let multi = this.setBuyerNo({
        ...multiParams,
        ...this.multiForm.getFieldsValue(),
        invoice_source: "01",
        file: multiParams.file,
      },form)
      for (let i in multi) {
        formData.append(i, multi[i]);
      }
      formData.append('sid', getSid())
    }
    let params =
      type === "add" || type === "edit"
        ? this.setBuyerNo({
          ...addParams,
          ...this.form.getFieldsValue(),
          sid: getSid(),
          invoice_date: moment(
            this.form.getFieldValue("invoice_date")
          ).format("YYYYMMDD"),
          buyer_tax_no: editData.buyer_tax_no || "",
          invoice_id: type === "edit" ? editData.invoice_id : "",
        },form)
        : formData;
    let url = apiHost +(type=='multiAdd'? "invoice/batch-create":"invoice/create")
    var handle_name = '发票'+(type=='multiAdd'?'批量创建':(handle[loadingStatus]||'创建'))
    handle_name
    ajaxApi({
      url: url,
      params: params,
    })
      .then((res) => {
        let judgeTrue =
          type === "add" || type === "edit"
            ? res.data.code == 200
            : res.data.code == 200 && get(res,'data.data.length') == 0;
        if (judgeTrue) {
          message.success(handle_name+'成功！')
          form && form.resetFields();
          this.props.clickCancel && this.props.clickCancel();
          this.setState({
            [loadingStatus]: false,
          });
          this.props.search && this.props.search(true, addParams.status);
        } else {
          this.setState({
            [loadingStatus]: false,
          });
          if(get(res,'data.data.length')){
            this.props.showErrModal(res.data.data)
            this.handleCancel()
          }else{
            message.success(handle_name+get(res,'data.message')+'!');
            form && form.resetFields();
            this.props.clickCancel && this.props.clickCancel(1);
          }
        }
      })
      .catch((e) => {
        message.error(handle_name+'失败！')
        this.props.clickCancel && this.props.clickCancel();
        form && form.resetFields();
        this.setState({
          [loadingStatus]: false,
        });
      });
  }, 1000);

  setBuyerNo=(params,form)=>{
    let {purchaseOptions} = this.state;
    var buyer_name
    if(get(purchaseOptions,'length')==1){
      set(params,'buyer_no',get(purchaseOptions,'0.value'))
      set(params,'buyer_no',get(purchaseOptions,'0.value'))
      buyer_name = get(purchaseOptions,'0.label')
    }else{
      buyer_name = get(_.filter(purchaseOptions,['value',form&&form.getFieldsValue().buyer_no]),'0.label')
    }
    set(params,'buyer_name',buyer_name)
    return params
  }

  handleCancel = () => {
    this.props.clickCancel && this.props.clickCancel();
    this.setState(
      {
        //   visible: false,
        amountTaxUpper: "",
        taxUpper: "",
      },
      () => {
        this.form.resetFields();
      }
    );
  };
  textAreaChange = (e, key) => {
    this.form.setFieldsValue({
      [key]: e.target.value,
    });
    this.setState({
      renderInvoiceType: e.target.value,
    })
  }
  
  changeFun(e, key) {
    let { renderInvoiceType, renderInvoiceNo, renderInvoiceCode,invoice_no_num } = this.state
    this.form.setFieldsValue({
      [key]: e.target.value,
    });
    var num = key == 'invoice_no' ? get(_.compact(e.target.value.split('\n')),'length'):invoice_no_num
    this.setState({
      renderInvoiceType: key == 'invoice_type' ? e.target.value : renderInvoiceType,
      renderInvoiceNo: key == 'invoice_no' ? e.target.value : renderInvoiceNo,
      renderInvoiceCode: key == 'invoice_code' ? e.target.value : renderInvoiceCode,
      invoice_no_num:num
    });
  }
  changeSelect(e, key) {
    let { type } = this.state;
    let form = type === "add" || type === "edit" ? this.form : this.multiForm;
    form &&
      form.setFieldsValue({
        [key]: e,
      });
  }
  beforeUpload = (file) => {
    return new Promise((resolve, reject) => {
      const size = file.file.size / 1024 / 1024;
      if (size > 100) {
        message.error("单个文件大小不能超过100M!");
        return reject(false);
      } else {
        return resolve(true);
      }
    });
  };
  changeUpload(file, types) {
    let { addParams, multiParams, type } = this.state;
    try {
      if (file.file.status === "done") {
        let newUrl = file.fileList.map((item) => {
          let data;
          if (item.response && item.response.data) {
            data = item.response.data;
          } else {
            data = item.url;
          }
          return { org_name: get(item, 'name'), file_name: data, ...item, url: data, name: data };
        });
        if (type === "add" || type === "edit") {
          addParams.invoice_file_list = newUrl;
          this.setState({ addParams: addParams });
          this.form.setFieldsValue({ appendix: newUrl })
        } else {
          if (types == "multiDetail") {
            multiParams.file = file.file.originFileObj;
          } else {
            multiParams.url = JSON.stringify(newUrl);
          }
          this.multiForm.setFieldsValue({ file: file.fileList })
          this.setState({
            multiParams: multiParams,
          });
        }
        this.setState({ fileList: newUrl })
      }
      this.setState({ fileList: file.fileList })

    } catch (err) { console.log(err) }
  }

  changeDetailUpload(file, types) {
    let { addParams, multiParams, type } = this.state;
    try {
      if (file.file.status === "done") {
        let newUrl = file.fileList.map((item) => {
          let data;
          if (item.response && item.response.data) {
            data = item.response.data;
          } else {
            data = item.url;
          }
          return { org_name: get(item, 'name'), file_name: data, ...item, url: data, name: data };
        });
        if (type === "add" || type === "edit") {
          addParams.invoice_file_list = newUrl;
          this.setState({ addParams: addParams });
          this.form.setFieldsValue({ appendix: newUrl })
        } else {
          if (types == "multiDetail") {
            multiParams.file = file.file.originFileObj;
          } else {
            multiParams.url = JSON.stringify(newUrl);
          }
          this.multiForm.setFieldsValue({ file: file.fileList })
          this.setState({
            multiParams: multiParams,
          });
        }
      }

    } catch (err) { console.log(err) }
  }
  onBlur(e, key) {
    if (key === "total_amount") {
      this.setState({
        amountTaxUpper: e.target.value,
      });
    } else {
      this.setState({
        taxUpper: e.target.value,
      });
    }
  }

  cancel = () => {
    this.props.rowCancel(null, this.state.editData)
    this.handleCancel();
  }
  renderMain = () => {
    let {
      btnParams,
      amountTaxUpper,
      taxUpper,
      purchaseOptions,
      type,
      editData,
      renderInvoiceType,
      fileList,
      renderInvoiceNo,
      renderInvoiceCode,
      invoice_no_num
    } = this.state;
    const props = {
      action: apiHost + "invoice/fims/file/upload",
      headers: {
        authorization: "authorization-text",
        ...tokenConfig
      },
      multiple: true,
      maxCount: 10,
      fileList: fileList,
      onPreview: async (file) => {
        var url = get(file, 'url') || get(file, 'response.data')
        if (url) {
          var download_url = await this.getUrl(url)
          if (download_url) {
            window.open(download_url)
          }
        }

      }
    };
    const detailProps = {
      action: apiHost + "invoice/fims/file/upload",
      headers: {
        authorization: "authorization-text",
        ...tokenConfig
      },
      multiple: true,
      maxCount: 10,
    };
    const invoice_type = renderInvoiceType || editData.invoice_type
    var invoice_no = this.form&&this.form.getFieldValue('invoice_no')
    var disabled = get(editData, 'status') == '05'||(get(editData, 'invoice_id')&&['02','05'].includes(get(editData, 'status')))
    return type === "add" || type === "edit" ? (
      <div className="addModal">
        <Form
          labelCol={{
            span: 4,
          }}
          ref={(refs) => {
            this.form = refs;
          }}
          wrapperCol={{
            span: 18,
          }}
        >
          <Form.Item
            name="invoice_id"
            label="发票单号："
          >
            {get(editData, 'invoice_id') || '保存时自动生成'}
          </Form.Item>
          {
            get(purchaseOptions,'length')>1&&
            <Form.Item
              name="buyer_no"
              label="结算主体："
              rules={[
                {
                  required: true,
                  message: "请选择结算主体",
                },
              ]}
            >
              <Select
                placeholder="请选择"
                showArrow
                disabled={disabled}
                onChange={(e) => {
                  this.changeSelect(e, "buyer_no");
                }}
                optionFilterProp="label"
                showSearch
              >
                {purchaseOptions.length > 0
                  ? purchaseOptions.map((item, index) => {
                    return (
                      <Option value={get(item, 'value')} key={index} label={get(item, 'label')}>
                        {get(item, 'label')}
                      </Option>
                    );
                  })
                  : null}
              </Select>
            </Form.Item>
          }
          
          <Form.Item
            name="invoice_type"
            label="发票类型："
            rules={[
              {
                required: true,
                message: "请选择发票类型",
              },
            ]}
          >
            <Radio.Group
              disabled={disabled}
              onChange={(e) => {
                this.changeFun(e, "invoice_type");
              }}
              value={btnParams.invoiceType}
              options={objToArr(get(this.props.enums, '发票类型枚举值(人工)'))}
            >
            </Radio.Group>
          </Form.Item>
          <Form.Item
            name="receipt_type"
            label="签收类型："
            initialValue={''}
          >
            {invoice_type &&
              <span className="redFont">{reseiptTypeObj[invoice_type]}</span>}
          </Form.Item>
          {
            invoice_type &&
            <Form.Item
              name="invoice_no"
              label="发票号码："
              rules={[
                {
                  required: (invoice_type == "X0") ? false : true,
                  message: "若输入多个发票，请用英文,隔开",
                },
              ]}
              initialValue={renderInvoiceNo}
            >
              <TextArea
                disabled={disabled}
                autoSize={{ minRows: 2 }}
                onFocus={() => {
                  this.form.setFieldsValue({
                    invoice_no: renderInvoiceNo && _.compact(renderInvoiceNo.split(',')).join('\n'),
                  })
                }}
                onBlur={() => {
                  this.form.setFieldsValue({
                    invoice_no: renderInvoiceNo && _.compact(renderInvoiceNo.split('\n')).join(','),
                  })
                }}
                onChange={(e) => {
                  this.changeFun(e, "invoice_no");
                }}
              ></TextArea>
            </Form.Item>
          }

          {invoice_type == "X0" || !invoice_type ? null : (
            <Form.Item
              name="invoice_code"
              label="发票代码："
              rules={[
                {
                  required: true,
                  message: "若输入多个发票，请用英文,隔开",
                },
              ]}
              initialValue={renderInvoiceCode}
            >
              <TextArea
                disabled={disabled}
                autoSize={{ minRows: 2 }}
                onFocus={() => {
                  this.form.setFieldsValue({
                    invoice_code: renderInvoiceCode && renderInvoiceCode.split(',').join('\n'),
                  })
                }}
                onBlur={() => {
                  this.form.setFieldsValue({
                    invoice_code: renderInvoiceCode && renderInvoiceCode.split('\n').join(','),
                  })
                }}
                onChange={(e) => {
                  this.changeFun(e, "invoice_code");
                }}
              ></TextArea>
            </Form.Item>
          )}

          <Form.Item
            name="invoice_date"
            label="开票日期："
            rules={[
              {
                required: true,
                message: "请输入开票日期",
              },
            ]}
          >
            <DatePicker  disabled={disabled}/>
          </Form.Item>
          <Form.Item
          name='invoice_no_num'
            label="发票数量："
          >
            <span>{invoice_no_num}</span>
          </Form.Item>
          <Form.Item
            name="total_amount"
            label="含税金额："
            rules={[
              {
                required: true,
                message: "请输入含税金额",
              },
              { pattern: /^[^\s]*$/, message: "禁止输入空格" },
            ]}
          >
            <InputNumber
              disabled={disabled}
              style={{ width: "100%" }}
              onBlur={(e) => this.onBlur(e, "total_amount")}
              placeholder="请输入金额,最多4位小数"
              max={99999999999999}
              onChange={(e) => {
                this.changeSelect(e, "total_amount");
              }}
            />
          </Form.Item>
          {amountTaxUpper && (
            <Form.Item>
              <span style={{ marginLeft: "22.667%" }} className='blueFont'>
                {moneyToUpper(amountTaxUpper)}
              </span>
            </Form.Item>
          )}
          <Form.Item
            name="tax_amount"
            label="税额："
            rules={[
              {
                required: true,
                message: "请输入税额",
              },
              { pattern: /^[^\s]*$/, message: "禁止输入空格" },
            ]}
          >
            <InputNumber
              disabled={disabled}
              style={{ width: "100%" }}
              placeholder="请输入金额,最多4位小数"
              max={99999999999999}
              onBlur={(e) => this.onBlur(e, "tax_amount")}
              onChange={(e) => {
                this.changeSelect(e, "tax_amount");
              }}
            />
          </Form.Item>
          {taxUpper && (
            <Form.Item>
              <span style={{ marginLeft: "22.667%", marginBottom: 5 }} className='blueFont'>
                {moneyToUpper(taxUpper)}
              </span>
            </Form.Item>
          )}
          <Form.Item name="remark" label="备注：" initialValue={''}>
            <TextArea
              disabled={disabled}
              onChange={(e) => {
                this.changeFun(e, "remark");
              }}
            ></TextArea>
          </Form.Item>
          {
            (invoice_type && invoice_type != '04') &&
            <Form.Item label="附件" rules={[{ required: true }]} name='appendix'>
              <Upload
                disabled={disabled}
                {...props}
                onChange={(file) => this.changeUpload(file)}
              >
                <Button icon={<UploadOutlined />} disabled={disabled}>上传文件</Button>
              </Upload>
              <div className="mt12 greyFont">支持拓展名：.rar,.zip,.pdf,.jpg...</div>
            </Form.Item>
          }
        </Form>
      </div>
    ) : (
      <div className="addModal">
        <Form
          labelCol={{
            span: 4,
          }}
          ref={(refs) => {
            this.multiForm = refs;
          }}
          wrapperCol={{
            span: 18,
          }}
        >
          {
            get(purchaseOptions,'length')>1&&
            <Form.Item
              name="buyer_no"
              label="结算主体："
              rules={[
                {
                  required: true,
                  message: "请选择结算主体",
                },
              ]}
            >
              <Select
                placeholder="请选择"
                showArrow
                onChange={(e) => {
                  this.changeSelect(e, "buyer_no");
                }}
                optionFilterProp="label"
                showSearch
              >
                {purchaseOptions.length > 0
                  ? purchaseOptions.map((item, index) => {
                    return (
                      <Option value={get(item, 'value')} key={index} label={get(item, 'label')}>
                        {get(item, 'label')}
                      </Option>
                    );
                  })
                  : null}
              </Select>
            </Form.Item>
          }
          <Form.Item
            label="发票明细："
            rules={[
              {
                required: true,
                message: "请上传发票明细附件",
              },
            ]}
            name="file"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
              }}
            >
              <Upload
                {...detailProps}
                onChange={(file) => this.changeDetailUpload(file, "multiDetail")}
              >
                <Button icon={<UploadOutlined />}>上传明细</Button>
              </Upload>
              <a
                style={{ marginLeft: 15 }}
                href="http://download.vsigo.cn/fims/%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx"
              >
                模板下载
              </a>
            </div>
            <div className="mt12 greyFont">支持拓展名：.xls,.xsls</div>
          </Form.Item>
          <Form.Item label="附件：">
            <Upload
              {...props}
              onChange={(file) => this.changeUpload(file, "multiWord")}
            >
              <Button icon={<UploadOutlined />}>上传文件</Button><span style={{ color: 'orange' }} className='ml8'>电子发票必填</span>
            </Upload>
            <div className="mt12 greyFont">支持拓展名：.rar,.zip,.pdf,.jpg...</div>

          </Form.Item>
        </Form>
      </div>
    );
  };
  render() {
    let {
      dialogTitle,
      editData,saveDisabled,submitDisabled
    } = this.state;
    var noFooter =get(editData, 'status') == '05'||(get(editData, 'invoice_id')&&['02','05'].includes(get(editData, 'status')))
    return (
      <Modal
        title={dialogTitle}
        visible={this.props.visible}
        width={"40%"}
        maskClosable={false}
        onCancel={this.handleCancel}
        footer={
          noFooter?[]:
          [
            <Button onClick={this.handleCancel}>取消</Button>,
            get(editData, 'status')&&(
              get(editData, 'status')=='00'||
              get(editData, 'status')=='02'&&['00'].includes(get(editData, 'matches_status'))
            ) && <Button onClick={this.cancel}>作废</Button>,
            (get(editData, 'status') == '00'||!get(editData, 'status'))  && (
              <Button
                onClick={this.save}
                loading={saveDisabled}
              >
                保存为草稿
              </Button>
            ),
            (get(editData, 'status') == '00'||!get(editData, 'status'))  && (
            <Button
              type="primary"
              loading={submitDisabled}
              onClick={this.submit}
            >
              提交并审核通过
            </Button>),
          ]
        }
      >
        {this.renderMain()}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/billVerification/createBills/artificialCreate/AddModal.jsx